import React, { useState } from "react";
import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import DeleteSupportForm from "./DeleteSupportForm";
// import { AppDispatch } from '../../../../store/app';
// import { useDispatch } from 'react-redux';
// import { statusAsteriskNumber } from '../../../../store/NumberManagementSlice';
import { PaginationProps } from "antd/lib/pagination";
import SendSupportViewStatus from "./SendSupportViewStatus";
import { CONSTANT } from "../../../config/Constant";
import moment from "moment";
// import DeleteForm from './DeleteForm';

interface DataType {
  key: string;
  id: string | any;
  number: string | any;
  providerType: string | any;
  name: string | any;
  active: boolean;
  file: string | any;
  code_providerName: string | any;
  created_at: any;
  updated_at: any;
}

const SendSupportListTable: React.FC<any> = (props) => {
  // const dispatch: AppDispatch = useDispatch();

  const {
    listData,
    setListData,
    tableloading,
    getList,
    totalData,
    setTableLoading,
    paginationData,
    setPaginationData,
  } = props;

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();
  const [openViewStatusDrawer, setOpenViewStatusDrawer] =
    useState<boolean>(false);
  const [openViewStatusData, setOpenViewStatusData] = useState<any>();

  const data: DataType[] = listData?.map((item, index: number) => ({
    key: index?.toString(),
    id: item?.index ?? index + 1,
    number: item?.number,
    name: item?.name,
    active: item?.active,
    file: item?.file_download_link, // Adjust this based on your actual data
    _id: item?._id,
    providerType: item?.providerType,
    code_providerName: item?.code_providerName,
    created_at: item?.created_at,
    updated_at: item?.updated_at,
  }));

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = () => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },

    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      width: 180,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.number || "").localeCompare(b.number || ""),
      render: (_, record) => {
        return record?.number ? record?.number : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 180,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (_, record) => {
        return record?.name ? record?.name : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Provider Type",
      dataIndex: "providerType",
      key: "providerType",
      width: 180,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.providerType || "").localeCompare(b.providerType || ""),
      render: (_, record) => {
        return record?.providerType
          ? record?.providerType
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Providers",
      dataIndex: "code_providerName",
      key: "code_providerName",
      width: 180,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.code_providerName || "").localeCompare(b.code_providerName || ""),
      render: (_, record) => {
        return record?.code_providerName
          ? record?.code_providerName
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 180,
      sorter: (a, b) =>
        moment(a.created_at).unix() - moment(b.created_at).unix(),
      render: (_, record) => {
        return record?.created_at ? record?.created_at : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 180,
      sorter: (a, b) =>
        moment(a.updated_at).unix() - moment(b.updated_at).unix(),
      render: (_, record) => {
        return record?.updated_at ? record?.updated_at : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: "Action",
      key: "action",
      width: 200,
      fixed: "right",
      // hidden: !checkPrivileges(userRoles, 'admin'),
      render: (_, record) => (
        <Space size="middle" wrap>
          <Tooltip title={"View Status"}>
            <Button
              onClick={() => {
                handleViewStatus(record);
              }}
              icon={<EyeOutlined />}
              type="default"
              target="_blank"
              className="iconBtn"
            />
          </Tooltip>
          <Tooltip title={"Download File"}>
            <Button
              href={record.file}
              icon={<CloudDownloadOutlined />}
              type="default"
              target="_blank"
              className="iconBtn"
            />
          </Tooltip>
          <Tooltip title={"Delete Number"}>
            <Button              
              onClick={() => {
                handleDeleteRequest(record);
              }}
              icon={<DeleteOutlined />}
              type="default"
              className="cancelBtn iconBtn"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleViewStatus = (record: any) => {
    setOpenViewStatusDrawer(!openViewStatusDrawer);
    setOpenViewStatusData(record);
  };
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
      </div>
      <div className="text-center mt-20 mb-30 providerTable">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current ?? 1}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>

      <DeleteSupportForm
        title={openDeleteData?.name}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?._id}
        name={"Number"}
        number={openDeleteData?.number}
        getList={getList}
      />
      <SendSupportViewStatus
        handleViewStatus={handleViewStatus}
        openViewStatusDrawer={openViewStatusDrawer}
        openViewStatusData={openViewStatusData}
      />
    </>
  );
};
export default SendSupportListTable;
